import { Injectable } from '@angular/core';
import { CookieService as cookieService, SameSite } from 'ngx-cookie-service';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })

export class CookieService extends cookieService {


    public setCookie(key: string, value: string, expires?: number | Date, secure?: boolean, sameSite?: SameSite, partitioned?: boolean): void {

        const domain = environment.production ? '.sandbox.co.in' : 'localhost';
        this.set(key, value, expires, '/', domain, secure ?? true, sameSite ?? 'Lax', partitioned);
    }

    public checkCookie(key: string): boolean {
        return this.check(key);
    }

    public getCookie(key: string): string {
        return this.get(key);
    }

    public deleteCookie(key: string, secure?: boolean, sameSite?: SameSite): void {
        const domain = environment.production ? '.sandbox.co.in' : 'localhost';
        this.delete(key, '/', domain, secure ?? true, sameSite ?? 'Lax');
    }
}
